import { ButtonGroup, ButtonIcon, Card, Icon, Tooltip, CardV2 } from 'pepsico-ds'
import React, { useEffect, useState } from 'react'
import './Cards.scss'
import SpendAnalyticsModal from '../Modal/SpendAnalyticsModal';
import ContractModal from '../Modal/ContractModal';
import ComanModal from "../Modal/ComanModal";
import MIInHouseModalNew from "../Modal/MIInHouseModalNew";
import SmartCubeModal from "../Modal/SmartCubeModal";
import { formatNumberWithCommas, splitValueWithUnit, returnHyphenIfNull } from '../../utils/utils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useSelector } from 'react-redux'
import { appNames } from '../../constants/appNames';
import SustainabilityModal from '../Modal/SustainabilityModal';
import { Row, Col, message } from "antd";
import SupplierPerformanceModal from '../Modal/SupplierPerformanceModal';
import InfoIcon from '../Icons/InfoIcon';
import { localStoreKeys } from '../../constants/localStoreKeys';
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { useDispatch } from 'react-redux';
import ArchletModal from '../Modal/ArchletModal';
import CompassModal from '../Modal/CompassModal';
import swal from 'sweetalert';
import CustomButtons from './CustomButtons';
import { staticNotes } from '../../constants/staticNotes';
import showNotificationModal from '../Notification/NotificationModal.js';
import MyRISModal from '../Modal/MyRISModal';
import EDF_checked from "../../../src/assets/EDF_checked.svg";

function KpiCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    
    const [openModal, setOpenModal] = useState(false)
    // const [userData, setUserData] = useState({})
    const userData = useSelector((state) => state.localData?.data?.oktaUserData);
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [appName, setAppName] = useState();
    const [dataIssueWarningText, setDataIssueWarningText] = useState("");
    const dispatch = useDispatch()

    // User data is now fetched from Redux store
    // No need for individual component fetching
    
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const tempbuttonGroupItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];

            setButtonGroupItems(tempbuttonGroupItems)
            if (capability == appNames.marketIntel) {
                const marketIntelApps = data?.apps?.filter((item) => item.app == "In-house MI Team");
                const tempObj = { key: localStoreKeys.marketIntelInhouseApps, value: marketIntelApps }
                dispatch(setKeyValue(tempObj))
            }

        }
    }, [data])

    const currentYearValue = splitValueWithUnit(data?.currentYearValue)?.['numericValue']

    /* istanbul ignore next */
    const vlaidateLandingPageFilters = (isSelectedFromSingleButton) => {
        // console.log("landingPageFilters", landingPageFilters);

        if (landingPageFilters.sectors.length > 0 && landingPageFilters.bus.length > 0 && landingPageFilters.l0s.length > 0) {
            if (capability === appNames.coman && isSelectedFromSingleButton) {

                // setAppName("Global SPM")
                setAppName("CoMan Automation")
                if (landingPageFilters.l1s.length > 0) {
                    setOpenModal(!openModal)
                } else {
                    message.warning("Please Select the required L1 filters")
                }
            } else if (landingPageFilters.l1s.length > 0) {
                setOpenModal(!openModal)
            } else {
                message.warning("Please Select the required L1 filters")
            }
        } else {
            message.warning("Please Select the required filters")
        }
    }
    
    /* istanbul ignore next */
    const buttonGroupDropdownItems = [
        { icon: "bar_chart", onClick: () => console.log("Bar chart clicked") },
        ...buttonGroupItems
            .filter((item) => item.label !== "AMESA Contract Analytics" 
            && item.label !== "AMESA PBI App" 
            && item.label !== "SAP Ariba CLM" 
            && item.label !== "Ariba CLM (LATAM & Europe)" 
            && item.label !== "Ariba CLM (NA)" 
            && item.label !== "Spendwise"
            && item.label !== "T-Contract"
            && item.label !== "Fieldglass"
            && item.label !== "myBUY"
            && !((item.label).includes("Insights Hub")))
            .map((item) => ({
                ...item,
                label: item.label + " - KPIs",
                disabled: !item.chartDisplay,
                onClick: () => {
                    if (item.chartDisplay) {
                        setAppName(item.label);
                        vlaidateLandingPageFilters(false)
                    } else {
                        showChartDisplayError()
                    }

                },
            })),
    ];
    let tempChartDisplay = true;
    buttonGroupDropdownItems.forEach((item) => {
        if (item.icon !== 'bar_chart' && tempChartDisplay) {
            tempChartDisplay = item.chartDisplay
        }
    })

    const enableChartDisplayButton = [appNames.spend, appNames.contract, appNames.sustainability, appNames.coman, appNames.compass, appNames.r2pInsights].includes(capability) &&
        buttonGroupDropdownItems.length < 3 && buttonGroupDropdownItems?.[1]?.chartDisplay;

    /* istanbul ignore next */
    const showChartDisplayError = () => {
        // swal({
        //     title: 'Data Unavailable',
        //     text: staticNotes.DATA_UNAVAILABLE_NOTE,
        //     icon: 'warning',
        //     button: "Go Back"
        // })
        //     .then(() => {
        //         console.log("chart is not accessible");

        //     })
        showNotificationModal({
            title: 'Data Unavailable',
            text: staticNotes.DATA_UNAVAILABLE_NOTE,
            icon: 'warning',
            button: "Go Back"
        })
        .then(() => {
            console.log("chart is not accessible");
        });
    }
    /* istanbul ignore next */
    useEffect(() => {
        const sectorSelected = landingPageFilters?.sectors
        const hasNonAMESA = sectorSelected.some(item => item.displayText !== "AMESA");
        const hasAMESA = sectorSelected.some(item => item.displayText === "AMESA");
        let appName = "Spend HQ"
        if (hasAMESA) {
            if (hasNonAMESA) {
                appName = "Spend HQ/AMESA PBI App"
            } else {
                appName = "AMESA PBI App"
            }
        }
        setDataIssueWarningText("Due to some updates in " + appName + ", numbers what you see here can differ slightly. This is expected to solve soon by app team");

    }, [landingPageFilters])

    
    return (
        <>
            {/* <div className="kpi-card" >  */}
            <div className="kpi-card-header">
                                    <div className="kpi-card-title">
                                        {data?.title}
                                        {
                                            data?.edfintegrated &&
                                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                            </Tooltip>
                                        }
                                    </div>
                                    {
                                        [appNames.spend, appNames.contract, appNames.sustainability, appNames.coman, appNames.compass, appNames.r2pInsights].includes(capability) &&
                                            buttonGroupDropdownItems.length < 3 ?
                                            <div className="kpi-card-header-icons">
                                                <ButtonIcon
                                                    icon="bar_chart"
                                                    // disabled={!enableChartDisplayButton}
                                                    disabled={disabled}
                                                    label=""
                                                    onClick={
                                                        () => {
                                                            if (!enableChartDisplayButton) {
                                                                showChartDisplayError()
                                                            } else {
                                                                vlaidateLandingPageFilters(true)

                                                            }
                                                        }}
                                                    size="medium"
                                                    type="default" />
                                            </div> :
                                            <ButtonGroup
                                                itemCount={1}
                                                groupDisabled = {disabled}
                                                items={buttonGroupDropdownItems}
                                                showMore
                                                disabled={disabled}
                                                size="medium"
                                                className="kpiCardButtomGroup"
                                            />
                                    }
                                </div>
                                {
                                    <div className="kpi-card-middle-content">
                                        <div className="kpi-card-middle-content-left">
                                            {
                                                data?.currentYearValue ?
                                                    <div className="kpi-card-alphanumeric-value">
                                                        {
                                                            capability != "Contract" && capability != appNames.sustainability && capability != appNames.marketIntel ?
                                                                <>
                                                                    <div className='kpi-card-numeric-value'>
                                                                        {formatNumberWithCommas(currentYearValue)}

                                                                    </div>
                                                                    <div className="kpi-card-alpha-value" style={{ display: "flex" }}>
                                                                        {splitValueWithUnit(data?.currentYearValue)?.['unit']}
                                                                        {
                                                                            capability == appNames.spend &&
                                                                            <Tooltip direction="right" 
                                                                                text={dataIssueWarningText}>
                                                                                <Icon alt="" icon="info" size="small" />
                                                                            </Tooltip>
                                                                        }
                                                                        {
                                                                            capability == appNames.coman &&
                                                                            <Tooltip direction="right" style={{ marginLeft: "130px" }}
                                                                                text={staticNotes.COMAN_CARD_NOTE}>
                                                                                <Icon alt="" icon="info" size="small" />
                                                                            </Tooltip>
                                                                        }
                                                                    </div>
                                                                </> :
                                                                <div className='kpi-card-numeric-value'>
                                                                    {
                                                                            // capability === appNames.coman 
                                                                            //     ? (
                                                                            //         <>
                                                                            //             {formatNumberWithCommas(data?.currentYearValue)}%
                                                                            //             <sup>
                                                                            //                 <InfoIcon text="SPM app under rework; KPIs may change" />
                                                                            //             </sup>
                                                                            //         </>
                                                                            //         ) 
                                                                            //     : 
                                                                                formatNumberWithCommas(data?.currentYearValue)
                                                                    }
                                                                    {(capability === appNames.sustainability && data?.currentYearValue != "N/A") // || capability === appNames.coman 
                                                                        ? <sup><InfoIcon text="Info available only at sector level" direction='right'/></sup> : ''}
                                                                    {capability === appNames.contract ? <sup><InfoIcon text="Active Contracts include 'Active' and 'In-Progress'" direction='right' /></sup> : ''}
                                                                    {capability === appNames.sustainability && data?.currentYearValue === "N/A" ? <sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right' /></sup> : ''}
                                                                </div>
                                                        }

                                                    </div>
                                                    :
                                                    <div className="kpi-card-alphanumeric-value">
                                                        <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text={capability===appNames.coman?staticNotes.COMAN_UNAVAILABLE_NOTE:staticNotes.DATA_UNAVAILABLE_NOTE} direction='right'/></sup></div>
                                                    </div>
                                            }
                                            <div className="kpi-card-numeric-value-tagline">{data?.description}</div>
                                            <div className="kpi-card-last-update">{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                        </div>

                                        {capability !== appNames.marketIntel && capability !== appNames.contract &&
                                            <div className="kpi-card-middle-content-right">
                                                <div className="kpi-card-last-year-value">
                                                    <span className="last-year">LY</span>
                                                    {
                                                        data?.lastYearValue ?
                                                            <>
                                                                {
                                                                    capability != "Contract" && capability != appNames.sustainability && capability != appNames.coman ?
                                                                        <>
                                                                            <span className="last-year-value">{splitValueWithUnit(data?.lastYearValue)?.['numericValue']}{splitValueWithUnit(data?.lastYearValue)?.['unit']}</span>
                                                                        </> :
                                                                        <span className="last-year-value">{formatNumberWithCommas(data?.lastYearValue)}</span>
                                                                }
                                                            </> : <span className="last-year-value">N/A</span>
                                                    }
                                                </div>
                                                {
                                                    data?.percentage ?
                                                        <>
                                                            <div className="kpi-card-percentage-value"
                                                                style={
                                                                    capability === appNames.sustainability
                                                                    ? {
                                                                        backgroundColor:
                                                                            parseFloat(data?.percentage) === 0
                                                                            ? "#66c0e3"
                                                                            : parseFloat(data?.percentage) > 0
                                                                            ? "#006A42"
                                                                            : "#AA001A",
                                                                        }
                                                                    : {}
                                                                }
                                                            >{data?.percentage}%
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon={parseFloat(data?.percentage) == 0 ? "" : (parseFloat(data?.percentage) > 0 ? "arrow_upward" : "arrow_downward")}
                                                                    size="small"
                                                                    style={{ color: '#fff' }}
                                                                />
                                                            </div>
                                                        </> : ""
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                <div className="kpi-card-footer">
                                    <CustomButtons appList={data?.apps} disabled={disabled}/>
                                </div>
            {/* </div> */}
            {
                openModal && capability == appNames.spend && <SpendAnalyticsModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal && capability == appNames.contract && <ContractModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal && capability == appNames.sustainability && <SustainabilityModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal && capability == appNames.coman && appName == "CoMan Automation" && <ComanModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal && capability == appNames.marketIntel && appName == "SmartCube" && <SmartCubeModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName ={appName}/>
            }

            {
                openModal && capability == appNames.marketIntel && appName == "In-house MI Team" && <MIInHouseModalNew openModal={openModal} setOpenModal={setOpenModal} userData={userData} capability={capability} selectedYear={selectedYear} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName ={appName} />
            }


            {
                openModal && capability == appNames.coman && appName == "Global SPM" && <SupplierPerformanceModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal && capability == appNames.compass && <CompassModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
            {
                openModal  && capability == appNames.r2pInsights && <MyRISModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
        </>
    )
}

export default KpiCard